export const lightPurple = "#BA90FC";
export const purple = "#995EF6";
export const white = "#fff";
export const gray200 = "#2d3033";
